(() => {
  const stop = new Set(['a','an','and','are','as','at','be','by','can','do','does','for','from','how','i','in','is','it','me','my','of','on','or','the','to','what','when','where','which','who','why','with']);
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const tokens = value => normalize(value).match(/[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]|[\p{L}\p{N}]+/gu)?.filter(word => !stop.has(word)) || [];
  function init(root) {
    if (!root || root.dataset.faqReady === 'true') return;
    const controls = root.querySelector('[data-faq-controls]');
    const form = root.querySelector('[data-faq-search-form]');
    const input = root.querySelector('[data-faq-search]');
    const clear = root.querySelector('[data-faq-clear]');
    const topics = [...root.querySelectorAll('[data-faq-topic]')];
    const items = [...root.querySelectorAll('[data-faq-item]')];
    const results = root.querySelector('[data-faq-results]');
    const empty = root.querySelector('[data-faq-empty]');
    const reset = root.querySelector('[data-faq-reset]');
    const expand = root.querySelector('[data-faq-expand]');
    if (!controls || !form || !input || !items.length || !results || !empty) return;
    root.dataset.faqReady = 'true';
    const itemTokens = new Map(items.map(item => [item, new Set(tokens(`${item.textContent} ${item.dataset.keywords || ''}`))]));
    let topic = items.some(item => item.dataset.common === 'true') ? 'common' : 'all';
    const search = () => {
      const query = tokens(input.value);
      const visible = [];
      items.forEach(item => {
        const categoryMatch = topic === 'all' || (topic === 'common' ? item.dataset.common === 'true' : item.dataset.category === topic);
        const text = itemTokens.get(item);
        const searchMatch = query.every(word => text.has(word));
        item.hidden = !(categoryMatch && searchMatch);
        if (!item.hidden) visible.push(item);
      });
      const count = visible.length;
      results.textContent = (topic === 'common' && !query.length ? results.dataset.common : count === 1 ? results.dataset.one : results.dataset.count).replace('{count}', count);
      empty.hidden = count !== 0;
      controls.hidden = false;
      if (expand) {
        expand.hidden = count === 0;
        const allOpen = visible.length > 0 && visible.every(item => item.open);
        expand.textContent = allOpen ? expand.dataset.collapse : expand.dataset.expand;
        expand.setAttribute('aria-expanded', String(allOpen));
      }
    };
    topics.forEach(button => button.addEventListener('click', () => {
      topic = button.dataset.faqTopic;
      topics.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      search();
    }));
    input.addEventListener('input', () => { if (input.value.trim() && topic === 'common') {
      topic = 'all'; topics.forEach(button => { const selected = button.dataset.faqTopic === 'all'; button.setAttribute('aria-pressed', String(selected)); });
    } search(); });
    form.addEventListener('submit', event => { event.preventDefault(); search(); });
    const clearQuery = () => { input.value = ''; search(); };
    if (clear) clear.addEventListener('click', clearQuery);
    if (clear) clear.addEventListener('click', () => input.focus());
    input.addEventListener('keydown', event => { if (event.key === 'Escape') clearQuery(); });
    if (reset) reset.addEventListener('click', () => {
      input.value = ''; topic = 'all';
      topics.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.faqTopic === 'all')));
      search(); input.focus();
    });
    if (expand) expand.addEventListener('click', () => {
      const visible = items.filter(item => !item.hidden);
      const shouldOpen = visible.some(item => !item.open);
      visible.forEach(item => { item.open = shouldOpen; }); updateExpand();
    });
    function updateExpand() {
      if (!expand) return;
      const visible = items.filter(item => !item.hidden);
      const allOpen = visible.length > 0 && visible.every(item => item.open);
      expand.textContent = allOpen ? expand.dataset.collapse : expand.dataset.expand;
      expand.setAttribute('aria-expanded', String(allOpen));
    }
    items.forEach(item => item.addEventListener('toggle', updateExpand));
    if (expand?.dataset.controls) expand.setAttribute('aria-controls', expand.dataset.controls);
    controls.hidden = false;
    topics.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.faqTopic === topic)));
    search();
  }
  document.querySelectorAll('[data-ceika-faq]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    if (event.target?.matches?.('[data-ceika-faq]')) init(event.target);
    else event.target?.querySelectorAll?.('[data-ceika-faq]').forEach(init);
  });
})();
